import script from "./find-property.vue?vue&type=script&setup=true&lang=ts"
export * from "./find-property.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__